// extracted by mini-css-extract-plugin
export default {"container":"LoadingOverlay-module__container--XAJuu","content":"LoadingOverlay-module__content--8I+zP","text":"LoadingOverlay-module__text--2mCx+"};